import Tools from './../components/sections/Tools/Tools';

const ToolsPage = () => {
  return (
    <>
      <Tools />
    </>
  );
};

export default ToolsPage;